import {IExpressOrder} from 'plugins/modules/filter/types';
import {createContext, Dispatch, SetStateAction} from 'react';
import {IDetectedCity} from 'modules/locations/models';

export interface IFilterPickupTodayButtonContext {
    cityData?: IDetectedCity;
    isShowExpressOrder?: boolean;
    isExpressOrderLoading?: boolean;
    setWineShop?: (shop: IExpressOrder | undefined) => void;
    wineShop?: IExpressOrder;
    handleResetPagination?: () => void;
    setHandleResetPagination?: Dispatch<SetStateAction<() => void>>;
}

export const FilterPickupTodayButtonContext = createContext<IFilterPickupTodayButtonContext>({});
